import { jsx as _jsx } from "react/jsx-runtime";
import BigNumber from 'big.js';
import { useCallback, useState } from 'react';
import { decimalNumberValidation } from 'common';
import { TextBody } from '../../atoms';
import { TextInput } from '../../molecules';
export function AmountInput({ displayCode, label, onChange, value }) {
    var _a;
    // State
    const [internalValue, setInternalValue] = useState((_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : '');
    // Handlers
    const handleChange = useCallback((text) => {
        // Type "." --> "0."
        let input = decimalNumberValidation(text);
        // Do not allow alphabetic characters
        input = input.replace(/[^0-9.]/g, '');
        if (input.endsWith('.') && input.split('.').length > 2) {
            // Do not allow more than one dot "." character
            input = input.slice(0, -1);
        }
        setInternalValue(input);
        if (input.endsWith('.')) {
            // No change event
            return;
        }
        try {
            onChange(BigNumber(input));
        }
        catch (_a) {
            onChange(null);
        }
    }, [onChange]);
    // Render
    return (_jsx(TextInput, { label: label, value: internalValue, onValueChange: handleChange, placeholder: "Enter amount", rightAddOn: displayCode ? _jsx(TextBody, { em: true, children: displayCode }) : undefined }));
}
